import React, { Component } from 'react';
import PrimeEntry from './components/PrimeEntry';
import NameNum from './components/NameNum';
import OTPDialogue from './components/OTPDialogue';
import IDNum from './components/IDNum';
import MainForm from './components/MainForm';
import IDDupDiag from './components/IDDupDiag';
import RegretPage from './components/RegretPage';
import MobileConf from './components/MobileConf';
import CheckAppStatus from './components/CheckAppStatus';
import TokenHandler from './components/TokenHandler';
import PayGateFrame from './components/PayGateFrame';

const resetState = {
    gwt: null,
    institution_name: null,
    info_email:null,
    domain:null,
    contact_phone:null,
    application_for: null,
    email: null,
    fname: null,
    lname: null,
    mobile: null,
    id_obj: {},
    form_min_age: null,
    form_max_age: null,
    form_url: null,
    form_title: null,
    form_token: null,
    user_status: null,
    unlocked_by_token_key: false, 
    showPrime: true, //start here...
    showNameNum: false,
    showOTPDialogue: false,
    showIDNum: false,
    showIDDuplicateDialog: false, 
    showRegret: false,
    showMobileConf: false,
    showCheckAppStatus: false,
    old_email: '',
    old_mobile: '',
    old_user_token: null,
    mobile_match: null,
    old_name_same: false,
    showMainForm: false,
    showPayGateFrame: false,
    id_on_file: false,
    may_reapply_on_form: false,
    paygate: null,
    auto_register: null,
    paygate_url: null,
    paygate_url_exe: null,
    paygate_amount : null,
    paygate_item : null,
    require_said: null,

}

class MainFrame extends Component {
    
    constructor(props) {
        super(props);
        this.state = resetState;
    }

    handleChildStateRequest = (newState) => {
        this.setState(newState);
    }

    resetState = () => {
        this.setState(resetState);
    }
    
    render() {
        return (
            <div style={{maxWidth:900}}> 

                {this.props.qparms.logo&&
                <img
                    src={"https://" + Buffer.from(this.props.qparms.logo,'base64').toString()}
                    alt="Logo"
                    height={150}
                />}

                {this.state.showPrime&&!this.props.otp_link&&
                <PrimeEntry setParentState={this.handleChildStateRequest} qparms={this.props.qparms} />}

                {this.props.otp_link&&!this.state.unlocked_by_token_key&&
                <TokenHandler setParentState={this.handleChildStateRequest} token={this.props.qparms.token} />}

                {this.state.showNameNum&&
                <NameNum setParentState={this.handleChildStateRequest}/>}

                {this.state.showOTPDialogue&&
                <OTPDialogue setParentState={this.handleChildStateRequest} myMail={this.state.email} fname={this.state.fname} lname={this.state.lname} mobile={this.state.mobile} gwt={this.state.gwt} id_on_file={this.state.id_on_file} applied_before={this.state.applied_before} custom_otp_message={this.state.custom_otp_message}/>}
                
                {this.state.showIDNum&&
                <IDNum setParentState={this.handleChildStateRequest} gwt={this.state.gwt} form_min_age={this.state.form_min_age} form_max_age={this.state.form_max_age} fname={this.state.fname} lname={this.state.lname} mobile={this.state.mobile} operation={this.props.qparms.operation} require_said={this.state.require_said}/>}

                {this.state.showIDDuplicateDialog&&
                <IDDupDiag setParentState={this.handleChildStateRequest} resetParentState={this.resetState} gwt={this.state.gwt} old_mobile={this.state.old_mobile} old_email={this.state.old_email} old_name_same={this.state.old_name_same} new_email={this.state.email} />}
                    
                {this.state.showRegret&&
                <RegretPage setParentState={this.handleChildStateRequest} gwt={this.state.gwt} institution_name={this.state.institution_name} domain={this.state.domain} contact_phone={this.state.contact_phone} info_email={this.state.info_email} id_obj={this.state.id_obj} />}

                {this.state.showMobileConf&&
                <MobileConf setParentState={this.handleChildStateRequest} gwt={this.state.gwt} old_mobile={this.state.old_mobile} mobile={this.state.mobile} mobile_match={this.state.mobile_match} old_user_token={this.state.old_user_token} institution_name={this.state.institution_name} contact_phone={this.state.contact_phone}  />}

                {this.state.showCheckAppStatus&&
                <CheckAppStatus setParentState={this.handleChildStateRequest} gwt={this.state.gwt} form_min_age={this.state.form_min_age} form_max_age={this.state.form_max_age} fname={this.state.fname} lname={this.state.lname} may_reapply_on_form={this.state.may_reapply_on_form} institution_name={this.state.institution_name} domain={this.state.domain} contact_phone={this.state.contact_phone} info_email={this.state.info_email} application_for={this.state.application_for} paygate_url={this.state.paygate_url} applicant_email={this.state.email} form_token={this.state.form_token} paygate_amount={this.state.paygate_amount} paygate_item={this.state.paygate_item}/>}

                {this.state.showMainForm&&
                <MainForm form_url={this.state.form_url} form_title={this.state.form_title} form_token={this.state.form_token} auto_register={this.state.auto_register} paygate={this.state.paygate} paygate_amount={this.state.paygate_amount} paygate_item={this.state.paygate_item}
                contact_phone={this.state.contact_phone} info_email={this.state.info_email}/>}

                {this.state.showPayGateFrame&&
                <PayGateFrame paygate_url={this.state.paygate_url_exe}/>}

            </div>
        );
    }
}

export default MainFrame;